import { pendingTask, begin, end } from '../constants/pendingTask';
import * as actions from './actionTypes';
import * as actionHelpers from '../scripts/actionHelpers';
import { fetchFromReitApi as fetch } from './fetchFromApi';

/**
 * Fetch analytics entitlement data from Auth API
 * Dispatches LOAD_PUBLISH_DATA_SUCCESS or LOAD_PUBLISH_DATA_FAILURE
 */
export const fetchPublicationData = (clientID, reportPeriodDescription) => {
  return (dispatch) => {
    dispatch({ type: actions.TASK_BEGIN, [pendingTask]: begin });
    let url = `/publicationData/getDataPublication?clientId=${clientID}`;
    if (reportPeriodDescription) {
      url = `/publicationData/getDataPublication?clientId=${clientID}&reportPeriodDescription=${reportPeriodDescription}`;
    }

    return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (actionHelpers.isErrorResponse(data)) {
          return actionHelpers.dispatchErrorAndEndTask(
            dispatch,
            actions.LOAD_PUBLISH_DATA_FAILURE,
            data
          );
        }

        dispatch({
          type: actions.LOAD_PUBLISH_DATA_SUCCESS,
          publishData: data,
          [pendingTask]: end,
        });

        return data;
      })
      .catch((error) => {
        return actionHelpers.dispatchErrorAndEndTask(
          dispatch,
          actions.LOAD_PUBLISH_DATA_FAILURE,
          null,
          error
        );
      });
  };
};
